module.exports = __webpack_public_path__ + "assets/img/activityImg3-649405e2.png";